import {
  Breadcrumb,
  Button,
  Divider,
  Form,
  Layout,
  Row,
  Col,
  message,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import MessageBoxInfo from "../commons/MessageBoxInfo";
import TextFieldGroup from "../commons/TextFieldGroup";
import { tailFormItemLayout, formItemLayout } from "./Layouts";

const { Content } = Layout;

const title = "Update Password";

const form_data = {
  _id: "",
  password: "",
  password_confirmation: "",
};

class UpdatePasswordForm extends Component {
  state = {
    title: "Update Password Form",
    url: "/api/users/update-password",

    errors: {},
    ...form_data,
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    const data = {
      ...this.state,
      user: this.props.auth.user,
    };
    axios
      .post(this.state.url, data)
      .then(({ data }) => {
        this.setState({
          ...form_data,
          errors: {},
          message: "Password updated",
        });

        message.success(this.state.message);
      })
      .catch((err) => {
        this.setState({ errors: err.response.data });
      });
  };

  addNew = () => {
    this.setState({
      ...form_data,
      errors: {},
      message: "",
    });
  };

  onHide = () => {
    this.setState({ message: "" });
  };

  render() {
    const { errors } = this.state;

    return (
      <Content className="content-padding">
        <div className="columns is-marginless">
          <div className="column">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item className="text-color-yellow">
                {title}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>

        <div
          style={{
            background: "#fff",
            padding: 24,
            minHeight: 280,
            borderRadius: 10,
          }}
        >
          <span className="module-title">{title}</span>
          <Divider />
          <Form>
            <TextFieldGroup
              label="Password"
              type="password"
              name="password"
              value={this.state.password}
              onChange={this.onChange}
              error={errors.password}
              formItemLayout={formItemLayout}
            />
            <TextFieldGroup
              label="Password Confirmation"
              type="password"
              name="password_confirmation"
              value={this.state.password_confirmation}
              onChange={this.onChange}
              error={errors.password_confirmation}
              formItemLayout={formItemLayout}
            />

            <Form.Item className="m-t-1" {...tailFormItemLayout}>
              <Button onClick={this.onSubmit} className="black-yellow control">
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Content>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(UpdatePasswordForm);
